import React from 'react';
import Tabs from '@atlaskit/tabs';
//@ts-ignore
import { ProductGroup, Product } from '../product';
import { Context } from 'src/content';
import './deployment-selector-tabs.less';
import analytics from '../../utils/analytics/analytics';
import camelCase from 'lodash/camelCase';
import get from 'lodash/get';

const handleTabSelect = (details: string, tab: string) => {
    const tabName = tab === 'Data Center and Server' ? 'Server' : tab;
    analytics.trackEvent(camelCase(tabName + ' tab'), {
        //@ts-ignore
        event: 'clicked',
        eventComponent: 'tab',
        category: 'products cloud and server tabs',
        actionSubjectId: camelCase(details + ' products ' + tabName + ' tab'),
        action: 'click',
        label: tab,
        contentful_entry_id: get(window, '__APP_INITIAL_STATE__.entry.id', null)
    });
};

const renderProducts = (products: Context[]) => {
    if (products?.length) {
        return products.map((item) => {
            const {
                productNameReference,
                icon,
                id,
                deploymentUrls,
                deployment
            } = item;
            if (deploymentUrls && icon) {
                return (
                    <Product
                        title={productNameReference.productName}
                        icon={icon.url}
                        key={id}
                        url={
                            deployment === 'Cloud'
                                ? deploymentUrls.cloud
                                : deploymentUrls.server
                        }
                        id={id}
                    />
                );
            }

            return [];
        });
    }
    return [];
};

export const DeploymentSelectorTabs = ({
    serverProducts,
    cloudProducts,
    details
}: {
    serverProducts: Context[];
    cloudProducts: Context[];
    details: string;
}) => {
    return (
        <Tabs
            tabs={[
                {
                    label: 'Cloud',
                    content: (
                        <ProductGroup>
                            {renderProducts(cloudProducts)}
                        </ProductGroup>
                    )
                },
                {
                    label: 'Data Center and Server',
                    content: (
                        <ProductGroup>
                            {renderProducts(serverProducts)}
                        </ProductGroup>
                    )
                }
            ]}
            onSelect={(selected) => {
                selected.label && handleTabSelect(details, selected.label);
            }}
        />
    );
};
